module.exports = __webpack_public_path__ + "img/screen_en.f346fff8.png";